import { render, staticRenderFns } from "./CollectedPaymentsReport.vue?vue&type=template&id=2f0317f0&scoped=true&"
import script from "./CollectedPaymentsReport.vue?vue&type=script&lang=js&"
export * from "./CollectedPaymentsReport.vue?vue&type=script&lang=js&"
import style0 from "./CollectedPaymentsReport.vue?vue&type=style&index=0&id=2f0317f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0317f0",
  null
  
)

export default component.exports